module.exports = __webpack_public_path__ + "static/images/event/object-to-path.png";